import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, canonical, ogType = 'website', ogImage = 'https://media-manager-c.questera.ai/greta-media/7c98abf852f963e06195176deed57bb9c81b4f53d205af5ca5b2f9af1b9cfaa840d35f6737e086b8644a3796bedcf0cc/images/aW1hZ2UvcG5n/51bb34f9956cf11fb97ebb2a9db89eac.png' }) => {
  const siteTitle = "AI CoLab Studio";
  const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
  const siteUrl = "https://aicolabstudio.com";
  const fullCanonical = canonical ? `${siteUrl}${canonical}` : siteUrl;

  const defaultDescription = description || "Helping leaders lead AI with confidence across their organisation without losing what makes them human.";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={defaultDescription} />
      <link rel="canonical" href={fullCanonical} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={defaultDescription} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={defaultDescription} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;